import React from "react";
import classNames from "classnames";

// MUI hook for styling function (stateless) components
import { makeStyles } from "@material-ui/core/styles";

// MUI Components
import Typography from "@material-ui/core/Typography";
import CircularProgress from "@material-ui/core/CircularProgress";
import Grid from "@material-ui/core/Grid";
import { colors } from "../../constants/colors";

const BottomValueDisplay = (props) => {
  const bottomLineStyles = makeStyles({
    root: {
      color: props.color,
    },
    iconContainer: {
      paddingBottom: "8px",
      width: "auto",
      flexBasis: props.small ? "25%" : "30%",
      "& svg": {
        fontSize: props.small ? "2.3rem" : "3.3rem",
      },
    },
    contentContainer: {
      flex: "1 0 auto",
      width: "auto",
    },
    title: {
      fontSize: props.small ? "0.875rem" : "1.3rem",
      fontWeight: 500,
    },
    value: {
      fontSize: props.small ? "2.5rem" : "3.5rem",
    },
    unitsContainer: {
      flex: "1 0 auto",
      marginLeft: props.small ? "2px" : "10px",
    },
    units: {
      fontSize: props.small ? "0.875rem" : "1.5rem",
      fontWeight: 600,
    },
    samples: {
      fontSize: "0.8rem",
      fontWeight: 100,
      marginTop: "-5px",
      paddingLeft: "5px",
    },
    circularProgress: {
      margin: "10px",
    },
    orange: {
      color: colors[props.theme].secondary,
    },
  });

  const classes = bottomLineStyles();
  return (
    <Grid container wrap="nowrap" className={classes.root}>
      {/* Icon */}
      <Grid
        item
        container
        xs={4}
        justify="center"
        alignItems="center"
        className={classes.iconContainer}
      >
        {props.icon}
      </Grid>

      <Grid
        item
        container
        xs={8}
        direction="column"
        className={classes.contentContainer}
      >
        {/* <Grid item>
          <Typography className={classes.title}>{props.title}</Typography>
        </Grid> */}
        {/* Main Data Display */}
        {props.value !== null ? (
          <Grid item container wrap="nowrap">
            <Grid item container alignItems="center">
              <Typography variant="h1" className={classes.value}>
                {props.value}
              </Typography>
            </Grid>
            <Grid
              item
              container
              direction="column"
              wrap="nowrap"
              justify="space-around"
              className={classes.unitsContainer}
            >
              <Grid item>
                {props.sampleCount > 1 && (
                  <Typography variant="body2">± {props.standardDev}</Typography>
                )}
              </Grid>
              <Grid item>
                <Typography className={classes.units}>
                  {` ${props.units}`}
                </Typography>
              </Grid>
            </Grid>
          </Grid>
        ) : (
          <CircularProgress
            className={classNames(
              classes.circularProgress,
              props.color === colors[props.theme].secondary
                ? classes.orange
                : ""
            )}
          />
        )}
        {/* Total Samples Used */}
        {props.value !== null && (
          <Grid item>
            <Typography variant="body2" className={classes.samples}>
              {props.sampleCount} sample
              {props.sampleCount > 1 && "s"}
            </Typography>
          </Grid>
        )}
      </Grid>
    </Grid>
  );
};

export default BottomValueDisplay;
